import {useSearchParams} from 'react-router-dom';
import {useCallback, useMemo} from 'react';
import {SingleValue} from 'react-select';
import {Transmission} from '../../../store/slices/occasions_slice';

interface TransmissionOption {
    label: string;
    value: Transmission;
}
export function useTransmission(transmission: string | undefined) {
    const transmissionOptions: TransmissionOption[] = useMemo(() => {
        return [
            {
                label: 'Handgeschakeld',
                value: Transmission.MANUAL,
            },
            {
                label: 'Automaat',
                value: Transmission.AUTOMATIC,
            },
        ];
    }, []);

    const selectedTransmissionOptions: TransmissionOption | null = useMemo(
        () => transmissionOptions?.find((to) => to.value === transmission) ?? null,
        [transmissionOptions, transmission],
    );

    const [, setSearchParams] = useSearchParams();
    const onSetTransmissionCallback = useCallback(
        (value: SingleValue<TransmissionOption>) => {
            setSearchParams((current) => {
                if (value?.value) {
                    current.set('transmission', value.value);
                } else {
                    current.delete('transmission');
                }
                current.delete('page');
                return current;
            });
        },
        [setSearchParams],
    );

    return {
        transmissionOptions,
        selectedTransmissionOptions,
        onSetTransmissionCallback,
    };
}
